<app-header></app-header>
<router-outlet></router-outlet>
<app-landingpage></app-landingpage>
<app-footer *ngIf="isIFrame()"></app-footer>